import { render } from "./FloatingWhatsappButton.vue?vue&type=template&id=04dabf1c&scoped=true"
import script from "./FloatingWhatsappButton.vue?vue&type=script&lang=js"
export * from "./FloatingWhatsappButton.vue?vue&type=script&lang=js"

import "./FloatingWhatsappButton.vue?vue&type=style&index=0&id=04dabf1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04dabf1c"]])

export default __exports__